import { extendTheme } from "@chakra-ui/react"
import { baseTheme } from "themes"

import { colors } from "./colors"
import { components } from "./components"
import { shadows } from "./shadows"
import { typography } from "./typography"

const creightonTheme = {
  colors,
  components,
  shadows,
  ...typography,

  styles: {
    global: {
      body: {
        fontWeight: "normal",
      },
      "#root": {
        backgroundColor: "pageBgColor",
        backgroundSize: {
          md: "100% 100vh",
        },
      },

      // Sign-Up / Sign-In Page Styles
      "#root.auth": {
        background: {
          md: `linear-gradient(165deg, #FCD344 40%, #FFC325 40%, #FFC325 45%, #FCD344 45%, #FCD344 50%, transparent 50%) no-repeat`,
        },
        "& .site-header": {
          borderBottom: { md: "none" },
          marginBottom: { md: 0 },
        },
      },

      ".country-list::-webkit-scrollbar": {
        width: "6px",
      },

      ".country-list::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px white",
      },

      " .country-list::-webkit-scrollbar-thumb": {
        backgroundColor: "#e4e7ed",
        borderRadius: "4px",
        height: "60px",
      },

      ".form-control:focus + .flag-dropdown .selected-flag, .flag-dropdown .selected-flag:focus + .form-control, .form-control:focus, .open, ":
        {
          backgroundColor: "white !important",
        },
      ".search": {
        width: "100%",
        borderBottom: "1px solid #ced0d4",
      },
      ".selected-flag": {
        paddingLeft: "15px !important",
      },
      ".country-list li": {
        marginTop: "8px !important",
        paddingRight: "10px !important",
      },

      ".error.react-tel-input:focus-within": {
        border: "2px solid #B01C2E !important",
        boxShadow: "0 0 6px 0 #B01C2E",
      },
      ".error": {
        border: "2px solid #B01C2E !important",
      },

      ".error .form-control, .error .flag-dropdown, .error .selected-flag": {
        border: "none",
        background: "white !important",
      },

      ".country:hover": {
        backgroundColor: "#C5E1FD !important",
      },

      ".country.highlight, .country.highlight .dial-code": {
        backgroundColor: "#2E82D7 !important",
        color: "white !important",
      },

      ".form-control:hover+.flag-dropdown, .form-control:hover": {
        border: "1px solid #0054A6 !important",
      },

      ".form-control:focus, .form-control:focus+.flag-dropdown, .form-control:focus+.flag-dropdown, .form-control.open, .flag-dropdown.open, .form-control.open:hover+.flag-dropdown":
        {
          border: "2px solid #0054A6 !important",
        },

      ".react-tel-input:hover .flag-dropdown, .form-control:focus+.flag-dropdown, .flag-dropdown.open, .form-control.open:hover+.flag-dropdown":
        {
          borderRight: "0px !important",
        },

      ".country-list": {
        marginTop: "3px !important",
      },

      ".flag-dropdown .selected-flag:hover": {
        borderRadius: "6px !important",
      },
    },
  },
}

const theme = extendTheme({ ...baseTheme }, creightonTheme)

export default theme
